import React from 'react';
import UploadButton from './Upload/Upload';
import UploadsView from './Upload/UploadsView';
import { useScreenSize } from '../hooks/useScreenSize';

const UploadsManager: React.FC = () => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex-column gap-2 w-100">
      <div className={`${isMobile ? 'flex-colomn' : 'flex-row space-between'}`}>
        <h3>My Gallery</h3>
        <div className="flex-row justify-end">
          <UploadButton />
        </div>
      </div>
      <UploadsView />
    </div>
  );
};

export default UploadsManager;
